module.exports = __webpack_public_path__ + "img/AP_dettaglioprodotto_368_corredo.90465e9c.png";